import React from "react";
import RecentlyViewed$ from "@deosite/components-new/RecentlyViewed";

const RecentlyViewed = props => <RecentlyViewed$ {...props} />;

export default RecentlyViewed;
